// test122
(122 && 0);
